export default __webpack_public_path__ + "static/media/undraw_In_progress_re_m1l6.56c08ffa.svg";